// Recovered compiled webpack factory 40479. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { U: () => n, f: () => s });
  let n = [
      "transformPerspective",
      "x",
      "y",
      "z",
      "translateX",
      "translateY",
      "translateZ",
      "scale",
      "scaleX",
      "scaleY",
      "rotate",
      "rotateX",
      "rotateY",
      "rotateZ",
      "skew",
      "skewX",
      "skewY",
    ],
    s = new Set(n);
}
